<script lang='ts'>
    import { round, type XSSDetails } from "@/Util/utils";
    import { ProgramTargetChangeValue } from ".";
    import TargetMarker from "./SetupFormInputs/SVGMarkers/TargetMarker.svelte";
    import CurrentMarker from "./SetupFormInputs/SVGMarkers/CurrentMarker.svelte";

    export let start: XSSDetails & { focusPower?: number }
    export let xpmcProj: XSSDetails & { focusPower?: number }
    export let required: XSSDetails & { focusPower?: number }
    export let final: XSSDetails & { focusPower?: number }

    export let xpmcDayTypeLabel: string
    export let forecastedDayTypeLabel: string
    export let lowLabel: string
    export let highLabel: string
    export let peakLabel: string
    export let totalLabel: string | null = null
    export let focusPowerLabel: string | null = null

    const labelAccessorColorArr = [
        { label: lowLabel, color: 'text-[--color-xlss]', key: 'xlss' },
        { label: highLabel, color: 'text-[--color-xhss]', key: 'xhss' },
        { label: peakLabel, color: 'text-[--color-xpss]', key: 'xpss' },
        { label: totalLabel, color: 'auto', key: 'xss' },
        { label: focusPowerLabel, color: 'var(--color-xert-teal)', key: 'focusPower' },
    ]
</script>

<table class="w-full border-collapse table-fixed text-left">
    <tr>
        <th></th>
        <th class="text-slate-500 font-normal">Start</th>
        <th class="text-slate-500 font-normal">
            <span class="hidden sm:inline">
                {forecastedDayTypeLabel}
            </span>
            <span class="sm:hidden inline h-[18px]">
                <TargetMarker class="text-blue-400 h-[18px]" strokeWidth={10}/>
            </span>
        </th>
        <th class="text-slate-500 font-normal">
            <span class="hidden sm:inline">
                {xpmcDayTypeLabel}
            </span>
            <span class="sm:hidden inline">
                <CurrentMarker class="text-blue-400 h-[12px]"/>
            </span>
        </th>
        <th class="text-slate-500 font-normal">Final</th>
    </tr>
    {#each labelAccessorColorArr as { label, color, key }}
        {#if label}
            <!-- {@const diff = roundTo1Decimal(xpmcProj[key] - required[key])} -->
            <tr>
                <td class={`left-col-width ${color}`}>{label}</td>
                <td class={`text-base`}>{start[key].toFixed(1)}</td>
                <td class={`text-base font-bold`}>{required[key].toFixed(1)}</td>
                <td>
                    <div class="flex flex-wrap gap-2 items-baseline">
                        <span class={`text-base`}>{xpmcProj[key].toFixed(1)}</span>
                        <ProgramTargetChangeValue class="border rounded-full border-black/10 px-1" value={round(xpmcProj[key] - final[key], 1)} />
                    </div>
                </td>
                <td class={`text-base`}>{final[key].toFixed(1)}</td>
            </tr>
        {/if}
    {/each}
</table>

<style>
    th {
        padding: 0 0 4px 0;
        vertical-align: bottom;
    }
    td {
        padding: 8px 0;
    }
    .left-col-width {
        width: 100px;
    }
    td + td {
        width: auto;
    }
    tr:last-child td {
        padding-bottom: 0;
    }
</style>